import script from "./doctorPage.vue?vue&type=script&setup=true&lang=js"
export * from "./doctorPage.vue?vue&type=script&setup=true&lang=js"

import "./doctorPage.vue?vue&type=style&index=0&id=c37e29be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c37e29be"]])

export default __exports__